module.exports = __webpack_public_path__ + "static/img/female-bg-fr.0e33bf4c.png";